import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResidentialHeader, residentialLogout, useResidentialBasePath } from '../ResidentialHome';

/**
 * Phase 5.D — profile menu.
 *
 * Top-of-list link is "בני הבית" — the only action big enough to
 * warrant the orange CTA treatment. Language / help / contact are
 * still stubs; they wire up alongside the SMS magic-link work
 * (Phase 5.F) and the Huri help-centre (Phase 7).
 */
function ResidentialProfile({ user, setUser }) {
  const basePath = useResidentialBasePath();
  const navigate = useNavigate();
  return (
    <>
      <ResidentialHeader
        title="הפרופיל שלי"
        subtitle={user?.name || user?.username}
        backTo={`${basePath}/`}
      />
      <div className="r-subpage">
        <button
          type="button"
          className="r-open-btn"
          onClick={() => navigate(`${basePath}/family`)}
          style={{ marginBottom: '1rem' }}
        >
          ניהול בני הבית
        </button>

        <div className="r-subpage-section">
          <h4>שפה</h4>
          <div className="value">עברית</div>
        </div>

        <div className="r-subpage-section">
          <h4>הדרכה</h4>
          <div className="value">בקרוב</div>
        </div>

        <div className="r-subpage-section">
          <h4>יצירת קשר עם Huri</h4>
          <div className="value">בקרוב</div>
        </div>

        <div className="r-subpage-section">
          <h4>גרסה</h4>
          <div className="value">5.0.0 (תצוגה מקדימה)</div>
        </div>

        <button
          type="button"
          className="r-logout-btn"
          onClick={() => residentialLogout(setUser)}
        >
          התנתק מהחשבון
        </button>
      </div>
    </>
  );
}

export default ResidentialProfile;
